export type TranzilaDocType = 'IR' | 'IN' | 'DI';

export interface TranzilaSettings {
  manual_push_documents:     boolean;
  default_document_type:     TranzilaDocType;
  document_date_source:      'today' | 'document';
  vat_source:                'system' | 'terminal';
  document_language:         'heb' | 'eng';
  send_client_company:       boolean;
  send_client_id:            boolean;
  send_client_email:         boolean;
  fallback_client_name:      string;
  include_item_code:         boolean;
  default_payment_method:    number;
  other_payment_description: string;
  cc_credit_term:            number;
  cc_installments:           number;
  bank_code:                 string;
  bank_branch:               string;
  bank_account:              string;
  ask_payment_each_time:     boolean;
  credit_enabled:            boolean;
  credit_document_type:      'IN' | 'IR';
  credit_link_original:      boolean;
  auto_email:                boolean;
  email_subject:             string;
  email_body:                string;
  email_cc:                  string;
}

export const DEFAULT_TRANZILA_SETTINGS: TranzilaSettings = {
  manual_push_documents:     true,
  default_document_type:     'IR',
  document_date_source:      'today',
  vat_source:                'system',
  document_language:         'heb',
  send_client_company:       true,
  send_client_id:            true,
  send_client_email:         true,
  fallback_client_name:      'לקוח כללי',
  include_item_code:         true,
  default_payment_method:    10,
  other_payment_description: 'תשלום באינטרנט',
  cc_credit_term:            1,
  cc_installments:           2,
  bank_code:                 '',
  bank_branch:               '',
  bank_account:              '',
  ask_payment_each_time:     false,
  credit_enabled:            false,
  credit_document_type:      'IN',
  credit_link_original:      true,
  auto_email:                false,
  email_subject:             "{סוג} מס' {מספר}",
  email_body:                "שלום {לקוח},\nמצורף קישור ל{סוג} מס' {מספר} על סך {סכום}.\nתודה!",
  email_cc:                  '',
};

export const PAYMENT_METHOD_OPTIONS = [
  { value: '1',  label: 'כרטיס אשראי' },
  { value: '3',  label: "צ'ק" },
  { value: '4',  label: 'העברה בנקאית' },
  { value: '5',  label: 'מזומן' },
  { value: '6',  label: 'PayPal' },
  { value: '10', label: 'אחר (למשל תשלום באינטרנט)' },
];

export const CREDIT_TERM_OPTIONS = [
  { value: '1', label: 'רגיל' },
  { value: '8', label: 'תשלומים' },
  { value: '6', label: 'קרדיט' },
];

export function readTranzilaSettings(raw: unknown): TranzilaSettings {
  return { ...DEFAULT_TRANZILA_SETTINGS, ...((raw ?? {}) as Partial<TranzilaSettings>) };
}
